// extracted by mini-css-extract-plugin
module.exports = {"ufb-logo":"ufb-section_ufb-logo__E6CKK","cta":"ufb-section_cta__tqVeL"};